<template>
	<div class="input-group">
    <div class="input-group-addon"><span>{{ title }}</span></div>
    <select class="form-control" v-model="selectedValue">
    	<option v-if="loading"><img src="@/assets/img/loading-mini.gif" alt=""></option>
      <option></option>
    	<option v-for=" (option, index) in options " :value="option" :key="index">{{ option }}</option>
    </select>
  </div>
</template>

<script>
	import axios from 'axios';
	import { mapGetters } from 'vuex';

	export default {
    props: ['title', 'searchField', 'searchCategory', 'value', 'reset'],
    data: () => {
      return{
        initialized: false,
        loading: false,
        options: [],
        selectedValue: '',
      }
    },
    created(){
    	this.loadOptions();
    },
    computed:{
      ...mapGetters(['getLocale', 'getApiUrl']), 
  	},
  	methods: {
  		loadOptions(){
  			if( !this.initialized ){
  				this.showLoading();
  				axios.get(this.getApiUrl + this.getLocale + '/' + this.searchCategory + '/autocomplete?campo=' + this.searchField)
  				.then( (respuesta) =>{
            this.options = respuesta.data.data;
  					this.initialized = true;
  					this.hideLoading();
          })
          .catch( (error) =>{ 
            //this.options = error.response.data.status + ' ' + error.response.data.msg;;
            //this.search_error_message = error.response.data.status + ' ' + error.response.data.msg;
            this.initialized = false;
            this.hideLoading();
          });
  			}
  		},
  		showLoading(){ this.loading = true; },
      hideLoading(){ this.loading = false; },
  	},
  	watch:{
  		selectedValue: function(){
  			this.$emit('update:value', this.selectedValue);
  		},
      reset: function(){
        this.selectedValue = '';
        this.$emit('update:value', this.selectedValue);
      }
  	}
  }
</script>
